import { IHistory, IForms } from '../../interfaces';
import * as React from 'react';
import { Cell } from '../reusableComponents/ChartComponents/Cell';
import CircularProgress from 'material-ui/CircularProgress';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Col, Row, DropdownButton, Dropdown, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { showDelConfirmModal } from '../../actions/modalActions';
import { IOIModelProps, OIModel } from '../../model/OIModel';
import { UserModel } from '../../model/UserModel';
import { connect } from 'react-redux';
import { FATick } from '../reusableComponents/FATIck';
import { getPageItemNumber } from '../../utils/generalUtils'; 
import { showCloseCallFollowUpListModal } from '../../actions/modalActions';   
import { setLoading } from '../../actions/loadingActions'; 
import { getAllFollowUpForms } from '../../services/closeCallService';   

const MenuItem = Dropdown.Item;
export interface IListItemProps {
    history?: {
        push: IHistory['push']
    };
    index?: number;
    instance?: OIModel;
    style?: React.CSSProperties; 
    currentPage?: number; 
    forms: IForms;
}

export class ListItemImpl extends React.PureComponent<IListItemProps, {}> {

    constructor(props: IListItemProps | Readonly<IListItemProps>) {
        super(props);
    }

    static defaultProps: IListItemProps;
    onDeleteAttribute(actionType: string) {
        const { instance } = this.props;  
        instance &&  showDelConfirmModal('delete-confirmation', 'O&I form', instance.props, actionType);  
    }
    onEditAttribute(instance: IOIModelProps & { key?: string | undefined; }) { 
        this.props.history?.push(`/oi-reports/edit/${instance.key}`);
    }
    onViewAttribute(instance: OIModel) { 
        if(!UserModel.checkUserAccess('o&i_view') )
            return;
        this.props.history?.push(`/oi-reports/${instance.props.id}`);
    }
    renderFormList = () => {
        const { instance, index, style } = this.props; 
        if (!instance) {
            return <MuiThemeProvider>
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <CircularProgress size={50} color="#88A4CE" />
                </div>
            </MuiThemeProvider>;
        }
        return (
            <Row className="report-row" style={style}
            >
                <Col sm={1}>
                        { ( UserModel.checkUserAccess('o&i_view') || UserModel.checkUserAccess('o&i_edit') || UserModel.checkUserAccess('o&i_delete') ) && <DropdownButton title="" id="bg-vertical-dropdown-3">
                            { UserModel.checkUserAccess('o&i_view') && <MenuItem eventKey="1"
                                onClick={() => this.props.history?.push(`/oi-reports/${instance.props.id}`)}
                                className="item"><i className="fa fa-eye" aria-hidden="true"></i> View</MenuItem> }
                            { UserModel.checkUserAccess('o&i_edit') && <MenuItem eventKey="2"
                                onClick={() => this.onEditAttribute(instance.props)}
                                className="item"><i className="fa fa-pencil" aria-hidden="true"></i> Edit</MenuItem> }
                            { UserModel.checkUserAccess('o&i_delete') && <MenuItem eventKey="3"
                                onClick={() => this.onDeleteAttribute('archive')}
                                className="item"><i className="fa fa-archive" aria-hidden="true"></i> Archive</MenuItem> }
                            { UserModel.checkUserAccess('o&i_delete') && <MenuItem eventKey="3"
                                onClick={() => this.onDeleteAttribute('delete')}
                                className="item"><i className="fa fa-trash" aria-hidden="true"></i> Delete</MenuItem> }
                        </DropdownButton> }
                        <span className="serial-no">{getPageItemNumber(index || 0, this.props.currentPage) }</span>
                </Col>
                <Cell sm={2} onClick={() => this.onViewAttribute(instance) }>{instance.props.dateReported || 'NA'}</Cell>
                <Cell sm={2} onClick={() => this.onViewAttribute(instance) }>{instance.props.username || 'NA'}</Cell>
                <Cell sm={2} onClick={() => this.onViewAttribute(instance) }>{instance.props.observation || 'NA'}</Cell>
                <Cell sm={2} onClick={() => this.onViewAttribute(instance) }>{instance.props.actionTaken || 'NA'}</Cell>
                <Col className="clickable-list-item" sm={2} onClick={() => this.onViewAttribute(instance) }>{instance.props.nearMiss === '1' ?
                    <FATick style={{ backgroundColor: '#26a65b', margin: 'auto' }} /> :
                    <FATick style={{ backgroundColor: '#ff7a7a', margin: 'auto' }} className="fa-times" /> }
                </Col>
                
                <Col className="clickable-list-item" sm={1} onClick={() => this.getFollowUpList(instance.props)} > 
                    <Button className="closecall-followup-button" > {instance.props.totalClosedFollowUp || '0'}/{instance.props.totalFollowUp || '0'}</Button> 
                </Col> 
            </Row >
        );
    }
    getFollowUpList(instance: IOIModelProps & { id?: string | undefined; }) { 
        if(!UserModel.checkUserAccess('follow_up_list') )
            return;
         
        let modalInstance: any = [];  
        modalInstance['closeCallId'] = instance['id'];
        modalInstance['followUpFor'] = instance; 
        showCloseCallFollowUpListModal(modalInstance);
        setLoading('CloseCallFollowUpList');
        getAllFollowUpForms(instance['id']);
    }
    render() {
        return this.renderFormList();
    }
}

export function mapStateToProps(state: any) {  
    return { 
        forms: state.forms,
    };
}

export const ListItem = withRouter(connect<IListItemProps, any, any>(mapStateToProps)(ListItemImpl));
